import { JSX } from 'react';
import { Database, ShieldCheck, Cpu, Server } from 'lucide-react';
import { SERVICE_NAMES, SERVICE_TIERS } from '../constants/infrastructure';

export const formatServiceName = (name: string): string => {
    const formatted = name.toLowerCase().trim();
    return SERVICE_NAMES[formatted] || name.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatUptime = (seconds: number): string => {
    if (seconds < 60) return `${Math.floor(seconds)}s`;

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ${(minutes % 60).toString().padStart(2, '0')}m`;

    const days = Math.floor(hours / 24);
    return `${days}d ${(hours % 24).toString().padStart(2, '0')}h`;
};

export const getServiceIcon = (name: string): JSX.Element => {
    const cleanName = name.toLowerCase().trim();
    if (SERVICE_TIERS.CORE.includes(cleanName)) return <Database className="w-4 h-4" />;
    if (SERVICE_TIERS.PLATFORM.includes(cleanName)) return <ShieldCheck className="w-4 h-4" />;
    if (SERVICE_TIERS.PROCESSING.includes(cleanName)) return <Cpu className="w-4 h-4" />;
    return <Server className="w-4 h-4" />;
};
